// Documentación:

// Para instalar y ejecutar esta aplicación, sigue los siguientes pasos:

// 1. Instalar Node.js y npm:
//    Descarga e instala Node.js desde https://nodejs.org. Node.js incluye npm (Node Package Manager),
//    que se utiliza para gestionar las dependencias de la aplicación.

// 2. Crear una nueva carpeta para el proyecto:
//    Abre una terminal o línea de comandos y crea una nueva carpeta para el proyecto con el comando:
//    mkdir nombre_de_la_carpeta

// 3. Navegar a la carpeta del proyecto:
//    Utiliza el comando cd para moverte a la carpeta recién creada:
//    cd nombre_de_la_carpeta

// 4. Inicializar el proyecto de React:
//    Ejecuta el siguiente comando para inicializar un nuevo proyecto de React:
//    npx create-react-app .
//    Esto creará una estructura de proyecto básica de React en la carpeta actual.

// 5. Reemplazar el archivo App.js:
//    Reemplaza el archivo App.js creado automáticamente por React con el código proporcionado.

// 6. Ejecutar la aplicación:
//    Para iniciar la aplicación, ejecuta el siguiente comando en la terminal dentro de la carpeta del proyecto:
//    npm start
//    Esto iniciará el servidor de desarrollo y abrirá automáticamente tu navegador web predeterminado
//    en la aplicación. Si no se abre automáticamente, puedes acceder a la aplicación abriendo tu navegador
//    y visitando la dirección http://localhost:3000.

// Importar React y el hook useState desde la biblioteca 'react'
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import routes from './config/routes';
import AuthProvider from "./providers/AuthProvider";
import './styles.css';
import ErrorBoundary from './ErrorBoundary';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <ErrorBoundary>
          <Routes>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <route.layout>
                    <route.component />
                  </route.layout>
                }
              />
            ))}
          </Routes>
        </ErrorBoundary>
      </Router>
    </AuthProvider>
  );
};

export default App;


